"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpeakerDetailsPage = void 0;
var _react = _interopRequireWildcard(require("react"));
var _personalDetails = require("../../personalDetails");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouter = require("react-router");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SpeakerDetailsPage = props => {
  const {
    speakersList,
    t
  } = props;
  const {
    speakerId
  } = (0, _reactRouter.useParams)();
  const personToDisplay = (0, _personalDetails.findPersonById)(speakersList, speakerId);
  const speakersDirectory = '/assets/images/speakers/';
  (0, _react.useEffect)(() => {
    document.title = "".concat(t('Pages.SpeakerDetails.Title'), ": ").concat(personToDisplay.name);
  }, []);
  const imageUrl = speakersDirectory + personToDisplay.image;
  return /*#__PURE__*/_react.default.createElement(_personalDetails.PersonalDetails, {
    person: personToDisplay,
    imageUrl: imageUrl,
    t: t
  });
};
exports.SpeakerDetailsPage = SpeakerDetailsPage;
SpeakerDetailsPage.propTypes = {
  speakersList: _propTypes.default.object,
  t: _propTypes.default.func
};